<template>
  <div>
    <header-bar>マイアーティスト</header-bar>
    <alert-view
      v-if="deletionError"
      title="エラーが発生しました"
      :errors="deletionError" />
    <div class="page-block myartist-detail">
      <div class="page-block__inner">
        <div class="artist-detail artist-detail-top">
          <div class="c-btn-wrap c-btn-wrap--artist-detail-top">
            <a
              class="c-btn c-btn--small"
              @click.prevent="onEditClicked">変更する
              <span class="c-btn__icon-arrow"></span>
            </a>
            <a
              v-if="!item.has_products"
              class="c-btn c-btn--delete-large c-btn--small"
              @click.prevent="onDeleteArtistClicked()">削除
            </a>
          </div>
          <div class="artist-detail__pic">
            <img
              :src="`/images/${item.image_path}`"
              alt="">
          </div>
          <div class="artist-detail__name">{{ item.name }}</div>
        </div>
        <div class="artist-detail">
          <span
            v-if="item.public_artist_link"
            class="public-artist"
            @click="copyOnClipBoard()">
            マイアーティストページ： <a
              :href="item.public_artist_link"
              target="_blank">{{ item.public_artist_link }}</a>
            <svg
              width="25px"
              height="25px"
              viewBox="0 0 48 48"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="#000000"
              style="transform: rotate(125deg);">
              <g
                id="SVGRepo_bgCarrier"
                stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"></g>

              <g
                id="SVGRepo_iconCarrier">
                <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
                <title>ic_fluent_link_48_filled</title>
                <desc>Created with Sketch.</desc>
                <g
                  id="🔍-Product-Icons"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd">
                  <g
                    id="ic_fluent_link_48_filled"
                    fill="#212121"
                    fill-rule="nonzero">
                    <path
                      id="🎨-Color"
                      d="
                         M33.25,13
                         C39.091302,13
                         43.8444515,17.6589349
                         43.9962593,23.4636156
                         L44,23.75
                         L44,24.25
                         C44,30.091302
                         39.3410651,34.8444515
                         33.5363844,34.9962593
                         L33.25,35
                         L28.75,35
                         C27.7835017,35
                         27,34.2164983
                         27,33.25
                         C27,32.3318266
                         27.7071103,31.5788077
                         28.6064728,31.5058012
                         L28.75,31.5
                         L33.25,31.5
                         C37.1739831,31.5
                         40.3698593,28.3826035
                         40.4961248,24.4893142
                         L40.5,24.25
                         L40.5,23.75
                         C40.5,19.8260169
                         37.3826035,16.6301407
                         33.4893142,16.5038752
                         L33.25,16.5
                         L28.75,16.5
                         C27.7835017,16.5
                         27,15.7164983
                         27,14.75
                         C27,13.8318266
                         27.7071103,13.0788077
                         28.6064728,13.0058012
                         L28.75,13
                         L33.25,13
                         Z
                         M19.25,13
                         C20.2164983,13
                         21,13.7835017
                         21,14.75
                         C21,15.6681734
                         20.2928897,16.4211923
                         19.3935272,16.4941988
                         L19.25,16.5
                         L14.75,16.5
                         C10.8260169,16.5
                         7.63014067,19.6173965
                         7.50387522,23.5106858
                         L7.5,23.75
                         L7.5,24.25
                         C7.5,28.1739831
                         10.6173965,31.3698593
                         14.5106858,31.4961248
                         L14.75,31.5
                         L19.25,31.5
                         C20.2164983,31.5
                         21,32.2835017
                         21,33.25
                         C21,34.1681734
                         20.2928897,34.9211923
                         19.3935272,34.9941988
                         L19.25,35
                         L14.75,35
                         C8.90869799,35
                         4.15554853,30.3410651
                         4.00374072,24.5363844
                         L4,24.25
                         L4,23.75
                         C4,17.908698
                         8.65893491,13.1555485
                         14.4636156,13.0037407
                         L14.75,13
                         L19.25,13
                         Z
                         M14,22.25
                         L34,22.25
                         C34.9664983,22.25
                         35.75,23.0335017
                         35.75,24
                         C35.75,24.9181734
                         35.0428897,25.6711923
                         34.1435272,25.7441988
                         L34,25.75
                         L14,25.75
                         C13.0335017,25.75
                         12.25,24.9664983
                         12.25,24
                         C12.25,23.0818266
                         12.9571103,22.3288077
                         13.8564728,22.2558012
                         L14,22.25
                         L34,22.25
                         L14,22.25
                         Z">
                    </path>
                  </g>
                </g>
              </g>
            </svg>
            <span
              v-if="isCopiedTextShown"
              class="copied-text">
              クリップボードにコピーしました
            </span>
          </span>
        </div>
        <div class="artist-detail artist-detail-profile">
          <h3
            class="artist-detail__title profile-title">
            PROFILE
          </h3>
          <p class="artist-detail__text wrap-text">{{ item.profile_ja }}</p>
        </div>
        <div
          v-if="singles.data.length > 0"
          class="artist-detail artist-detail-single">
          <h3 class="artist-detail__title">SINGLE</h3>
          <div class="artist-detail__disc-list-flex">
            <div
              v-for="(single, index) in singles.data"
              :key="index"
              class="artist-detail__disc-list">
              <a
                class="artist-detail__disc-list-item js-modal-open"
                href="#"
                @click.prevent="onProductClicked(single.id)">
                <div
                  class="artist-detail__disc-list-pic"
                  :style="`background-image: url(/images/${single.coverart_filepath})`">
                </div>
                <div class="artist-detail__disc-list-name">
                  <span class="artist-detail__disc-list-name_text">
                    {{ anyTitle(single) }}
                  </span>
                  <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
                </div>
              </a>
            </div>
          </div>
          <div class="pager">
            <div
              v-if="singles.data"
              class="pager">
              <pagination
                :pagination="singles"
                @on-pagination-clicked="onSinglePaginationClicked">
              </pagination>
            </div>
          </div>
        </div>
        <div
          v-if="albums.data.length > 0"
          class="artist-detail artist-detail-album">
          <h3 class="artist-detail__title">ALBUM / EP</h3>
          <div class="artist-detail__disc-list-flex">
            <div
              v-for="(album, index) in albums.data"
              :key="index"
              class="artist-detail__disc-list">
              <a
                class="artist-detail__disc-list-item js-modal-open"
                href="#"
                @click.prevent="onProductClicked(album.id)">
                <div
                  class="artist-detail__disc-list-pic"
                  :style="`background-image: url(/images/${album.coverart_filepath})`">
                </div>
                <div class="artist-detail__disc-list-name">
                  <span class="artist-detail__disc-list-name_text">
                    {{ anyTitle(album) }}
                  </span>
                  <span class="c-btn__icon-arrow c-btn__icon-arrow--def"></span>
                </div>
              </a>
            </div>
          </div>
          <div class="pager">
            <div
              v-if="albums.data"
              class="pager">
              <pagination
                :pagination="albums"
                @on-pagination-clicked="onAlbumPaginationClicked">
              </pagination>
            </div>
          </div>
        </div>
      </div>
      <div
        class="single-column__inner">
        <div class="c-btn-wrap">
          <a
            href="#"
            class="c-btn c-btn--back c-btn--back-left"
            @click.prevent="onBackClicked">戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </a>
        </div>
      </div>
    </div>
    <release-modal
      :id="currentProductId"
      :is-shown="productDetailShown"
      @closed="productDetailShown = false"
      @cancel-clicked="productDetailShown = false">
    </release-modal>

    <confirm-dialog
      name="deleteArtist"
      :is-shown="deleteArtistShown"
      title="アーティストの削除"
      @closed="deleteArtistShown = false"
      @default-clicked="onDefaultClicked"
      @cancel-clicked="deleteArtistShown = false">
      <template #body>
        削除します。<br />
        よろしいですか？
      </template>
    </confirm-dialog>
  </div>
</template>

<script>

import HeaderBar from '../HeaderBar'
import ReleaseModal from '../Release/ReleaseModal'
import ConfirmDialog from '../../../components/ConfirmDialog'
import Pagination from '../../../components/Pagination'
import AlertView from '../AlertView'
import {
  CMAP_RELEASE_STATUS_PUBLISHED,
  CMAP_RELEASE_STATUS_EDITING,
  CMAP_RELEASE_STATUS_APPEND_DSP,
  CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN,
  CMAP_RELEASE_STATUS_UPLOADING_TAKE_DOWN,
} from '../../../consts/status'

export default {
  name: 'ArtistDetail',
  components: {
    AlertView,
    Pagination,
    ReleaseModal,
    HeaderBar,
    ConfirmDialog,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      item: {
        has_products: true,
      },
      singles: { data: [] },
      albums: { data: [] },
      productDetailShown: false,
      currentProductId: '',
      deleteArtistShown: false,
      deletionError: [],
      isCopiedTextShown: false,
    }
  },
  computed: {
    profileJa() {
      return this.item.profile_ja
        ? this.item.profile_ja.replace(/\n/g, '<br/>')
        : ''
    },
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      try {
        const response = await window.axios.get(`/api/client/artists/${this.id}`)
        this.item = response.data

        this.fetchSingles()
        this.fetchAlbums()
      } catch ({ response }) {
        if (response.status === 404) {
          this.$router.push({ name: 'index' })
        }
      }
    },
    async fetchSingles(page = 0) {
      const { data } = await window.axios.get('/api/client/products', {
        params: {
          artist_id: this.id,
          release_status: [
            CMAP_RELEASE_STATUS_PUBLISHED,
            CMAP_RELEASE_STATUS_EDITING,
            CMAP_RELEASE_STATUS_APPEND_DSP,
            CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN,
            CMAP_RELEASE_STATUS_UPLOADING_TAKE_DOWN,
          ],
          type: 'single',
          count: 8,
          page,
        },
      })
      this.singles = data
    },
    async fetchAlbums(page = 0) {
      const { data } = await window.axios.get('/api/client/products', {
        params: {
          artist_id: this.id,
          release_status: [
            CMAP_RELEASE_STATUS_PUBLISHED,
            CMAP_RELEASE_STATUS_EDITING,
            CMAP_RELEASE_STATUS_APPEND_DSP,
            CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN,
            CMAP_RELEASE_STATUS_UPLOADING_TAKE_DOWN,
          ],
          type: 'album',
          count: 8,
          page,
        },
      })
      this.albums = data
    },
    onProductClicked(id) {
      this.currentProductId = id
      this.productDetailShown = true
    },
    onEditClicked() {
      this.$router.push({ name: 'artist-edit', params: { id: this.id } })
    },
    onDeleteArtistClicked() {
      this.deleteArtistShown = true
    },
    async onDefaultClicked() {
      try {
        await window.axios.delete(`/api/client/artists/${this.id}`)
        this.$router.push({ name: 'artist-index' })
      } catch {
        this.deletionError = [{ text: '削除に失敗しました' }]
        this.deleteArtistShown = false
        this.fetchItem()
      }
    },
    onBackClicked() {
      this.$router.go(-1)
    },
    anyTitle(item) {
      return item.title || (item.titles.length > 0 ? item.titles[0].title : '')
    },
    onSinglePaginationClicked(page) {
      this.fetchSingles(page)
    },
    onAlbumPaginationClicked(page) {
      this.fetchAlbums(page)
    },
    async copyOnClipBoard() {
      try {
        await navigator.clipboard.writeText(this.item.public_artist_link)
        this.isCopiedTextShown = true
        setTimeout(() => {
          this.isCopiedTextShown = false
        }, 2000)
        // eslint-disable-next-line no-empty
      } catch (err) {}
    },
  },
}
</script>

<style scoped>
.artist-detail__name {
  word-break: break-all;
}

.product-modal {
  padding: 20px;
  text-align: left;
  height: 80vh;
  overflow: scroll;
}

@media screen and (min-width: 896px) {
  .c-btn-wrap--artist-detail-top {
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 20px;
    top: 0;
    width: 344px;
  }
}

@media screen and (max-width: 895px) {
  .c-btn-wrap--artist-detail-top {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
}

@media screen and (min-width: 896px) {
  .c-btn--small {
    font-size: 1.8rem;
    min-width: 160px;
    padding: 9px 40px;
    text-align: center;
  }
}

@media screen and (max-width: 895px) {
  .c-btn--small {
    font-size: 3.73333vw;
    padding: 2.66667vw 5.33333vw;
    width: 48.5%;
  }
}
.wrap-text {
  white-space: pre-line;
  word-break: break-all;
}
</style>
